<template>
  <section v-if="result?.items" class="main-banner-dual">
    <a
      v-for="item in result.items"
      :key="item.id"
      :href="item.link || item.detailPage"
      class="main-banner-dual__item"
    >
      <DefVideo v-if="item.video" :result="item.video" loop />
      <DefImg v-else-if="item.picture" :result="item.picture" />
      <DefPicture v-else :result="item.animation || item.pictures" />
    </a>
  </section>
</template>

<script>
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'MainBannerDual',
  components: {
    DefImg,
    DefVideo,
    DefPicture,
  },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.main-banner-dual {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 64px;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include point-lg {
    margin-bottom: 80px;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :deep(.def-picture) {
    width: 100%;
  }
}
</style>
